<template>
    <ion-grid class="deal-list">
        <ion-row>
            <ion-col v-for="deal of deals" :key="deal.id" size-xl="4" size-lg="6" size="12">
                <ion-card class="card">
                    <router-link :to="{name: 'deal', params: { id: deal.id }}">
                        <img :src="deal.pic" />
                        <div class="triangle"></div>
                        <ion-icon :name="getDealIcon(deal.type).name" class="deal-type" :class="getDealIcon(deal.type).css"></ion-icon>
                        <ion-item class="time" lines="none"><ion-icon name="time"></ion-icon><ion-label>{{deal.when}}</ion-label></ion-item>
                        <ion-card-header align-self-center>
                            <ion-grid>
                                <ion-row>
                                    <ion-col size="9" class="title" align-self-end>
                                        {{deal.title}}
                                    </ion-col>
                                    <ion-col class="price" align-self-end>
                                        <ion-list>
                                            <ion-item lines="none" text-right>
                                                <ion-label class="from">{{ $t('components.deal-summary.from') }}</ion-label>
                                                <ion-label v-if="deal.currency == '$' || deal.currency == '£'">{{deal.currency}} {{deal.cost}}</ion-label>
                                                <ion-label v-else>{{deal.cost}} {{deal.currency}}</ion-label>
                                            </ion-item>
                                        </ion-list>
                                    </ion-col>
                                </ion-row>
                            </ion-grid>
                        </ion-card-header>
                    </router-link>
                </ion-card>
            </ion-col>
        </ion-row>
    </ion-grid>
</template>

<script>
export default {
  name: 'DealSummary',
  props: {
    deals: Array,
  },
    methods: {
      getDealIcon: function(type) {
          switch(type) {
              case 'flight':
                  return {
                      'name':'airplane',
                      'css':'rotate-45'
                  };

              case 'package':
                  return {
                      'name': 'cube',
                      'css': 'smaller'
                  };

              case 'cruise':
                  return {
                      'name': 'boat',
                      'css': 'smaller'
                  };

              case 'accommodation':
                  return {
                      'name': 'bed',
                      'css': 'smaller'
                  };

              case 'train':
                  return {
                      'name': 'train',
                      'css': 'smaller'
                  };

              case 'bus':
                  return {
                      'name': 'bus',
                      'css': 'smaller'
                  };

              default:
                  return {
                      'name': 'help',
                      'css': ''
                  };
          }
      }
    }
};
</script>

<style scoped>
    ion-col {
        padding: 0;
    }

ion-icon {
    z-index: 99;
}

ion-card-header {
    position: absolute;
    bottom: 0;
    width: 100%;
    padding: .5em .75em;
    background: rgba(0,0,0,.7);
    font-weight: bold;
}

ion-card-header ion-grid {
    padding: 0;
}

ion-card-header ion-col {
    height: 100%;
    padding: 0;
}

ion-card-content {
    background: rgba(0,0,0,.5);
}

ion-card-content ion-list {
    background: none;
}

ion-card-content ion-item {
    --background: none;
    --min-height: 2em;
    color: #fff;
    font-size: .9em;
}

ion-badge {
    margin-right: 10px;
    --padding-start: 10px;
    --padding-bottom: 10px;
    --padding-top: 10px;
    --padding-end: 10px;
}

ion-grid.deal-list {
    padding: 0;
}

.deal-list ion-card {
    --background: rgba(255,255,255,.8);
}

.triangle {
  position: absolute;
  top: -2.8em;
  left: -2.8em;
  width: 5.6em;
  height: 5.6em;
  transform: rotate(45deg);
  background: #f05;
}

.deal-type {
    top: .1em;
    left: .1em;
    position: absolute;
    font-size: 2em;
}

.rotate-45 {
    transform: rotate(45deg);
}

.smaller {
    font-size: 1.7em;
    top: .15em;
    left: .15em;
}

.card {
    position: relative;
}

.card a {
    text-decoration: none;
    color: #fff;
}

.title {
    font-size: calc(.9em + .8vw);
    color: #fff;
    line-height: calc(1.3em + .8vw);
}

.price ion-list {
    background: none;
    padding: 0;
}

.price ion-item {
    --background: none;
    --min-height: 0;
    --color: #f05;
    --inner-padding-end: 0;
    font-size: calc(1.2em + .8vw);
}

.price ion-label {
    font-family: 'Nunito', sans-serif;
    margin: 0;
    padding-top: .1em;
}

.price .from {
    font-size: .4em;
    color: #b05;
    position: absolute;
    right: 0;
    top: -.35em;
}

.time {
    font-size: .8em;
    position: absolute;
    z-index: 99;
    top: 0;
    right: 0;
    color: #fff;
    --background: rgba(0,0,0,.2);
    --padding-start: .5em;
    --padding-end: 0;
    --inner-padding-end: 0;
    --min-height: 2em;
}

.time ion-label {
    margin: .5em;
}

.time ion-icon {
    font-size: 1.1em;
    color: #fff;
}
</style>
